import { MantineThemeOverride } from '@mantine/core';

export type AspectRatioTheme = NonNullable<MantineThemeOverride['components']>['AspectRatio'];

export const AspectRatio: AspectRatioTheme = {
  // todo: define
};
